import React from "react";
import Typography from "../../../Utility/Typography";

const VendorTagMappingHeader = ({
  title = "Vendor Tag Mapping",
  subtitle = "Map your vendor tags to accounting categories used in QuickBooks.",
}) => {
  return (
    <div className="mt-2">
      <div className="flex flex-col gap-1">
        <Typography variant="h5" className="text-text-primary font-semibold">
          {title}
        </Typography>

        <Typography variant="body2" className="text-text-secondary">
          {subtitle}
        </Typography>
      </div>
    </div>
  );
};

export default VendorTagMappingHeader;
